const RESET = '\u001B[0m '; //	모든 색과 스타일 초기화

const BOLD = '\u001B[1m '; //	굵게(bold) / 밝게
const ITALIC = '\u001B[3m '; //	이탤릭체(italic)
const UNDERLINE = '\u001B[4m '; //	밑줄(underline)
const REVERSAL = '\u001B[7m '; //	반전(글자색/배경색을 거꾸로)
const STRIKE = '\u001B[9m '; //	가로줄 치기

const BLACK = '\u001B[30m'; //	글자색: 검정
const RED = '\u001B[31m'; //	글자색: 빨강
const GREEN = '\u001B[32m'; //	글자색: 초록
const YELLOW = '\u001B[33m'; //	글자색: 노랑
const BLUE = '\u001B[34m'; //	글자색: 파랑
const PINK = '\u001B[35m'; //	글자색: 마젠트(분홍)
const CYAN = '\u001B[36m'; //	글자색: 시안(청록)
const WHITE = '\u001B[37m'; //	글자색: 백색

// memory: any;
// assert(condition?: boolean, ...data: any[]): void;
// clear(): void;
// count(label?: string): void;
// countReset(label?: string): void;
// debug(...data: any[]): void;
// dir(item?: any, options?: any): void;
// dirxml(...data: any[]): void;
// error(...data: any[]): void;
// exception(message?: string, ...optionalParams: any[]): void;
// group(...data: any[]): void;
// groupCollapsed(...data: any[]): void;
// groupEnd(): void;
// info(...data: any[]): void;
// log(...data: any[]): void;
// table(tabularData?: any, properties?: string[]): void;
// time(label?: string): void;
// timeEnd(label?: string): void;
// timeLog(label?: string, ...data: any[]): void;
// timeStamp(label?: string): void;
// trace(...data: any[]): void;
// warn(...data: any[]): void;

export const logging = (color, target) => {
  if (target instanceof Object) console.log(color + JSON.stringify(target, null, 2) + RESET);
  else console.log(color + target + RESET);
};
export const extendConsole = () => {
  console.bold = str => logging(BOLD, str);
  console.italic = str => logging(ITALIC, str);
  console.underline = str => logging(UNDERLINE, str);
  console.reversal = str => logging(REVERSAL, str);
  console.strike = str => logging(STRIKE, str);

  console.black = str => logging(BLACK, str);
  console.red = str => logging(RED, str);
  console.green = str => logging(GREEN, str);
  console.yellow = str => logging(YELLOW, str);
  console.blue = str => logging(BLUE, str);
  console.pink = str => logging(PINK, str);
  console.cyan = str => logging(CYAN, str);
  console.white = str => logging(WHITE, str);
};
